export default __webpack_public_path__ + "static/media/green-4.082af1eb.png";